import { Component, Input, OnInit, SimpleChanges, ɵConsole, Output, EventEmitter } from '@angular/core';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import {CarritoHeader} from 'src/app/modal/carrito/carrito-header';
import { LibroDetalle } from 'src/app/modal/catalogo/libro-detalle';
import { retry } from 'rxjs/operators';
import { SourvenirDetalleResponse } from 'src/app/modal/sourvenir/sourvenir-detalle-response';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { Router } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { ModalHomeComponent } from 'src/app/modal-home/modal-home.component';

@Component({
  selector: 'app-carrito-compras-header',
  templateUrl: './carrito-compras-header.component.html',
  styleUrls: ['./carrito-compras-header.component.scss']
})
export class CarritoComprasHeaderComponent implements OnInit {
  carritoDetalle:CarritoHeader;
  carritoCompras=[];
  libroDetalle:LibroDetalle;
  precioTotal:number;
  precio:number;
  carritoComprasTemp=[];
  protectedImages: Map<string, SafeUrl> = new Map();
  loadingImages: Set<string> = new Set();
  isLoadingCart: boolean = false;
  isReloading: boolean = false; // Flag para cuando se está recargando después de eliminar
  itemsLoading: Set<number> = new Set(); // Track which items are loading
  monedaCarrito: string = 'S/.'; // Moneda del carrito (S/. o US$)

  @Input() flagActualizar: number;
  @Output() itemEliminado = new EventEmitter<void>();
  @Output() cerrarDropdown = new EventEmitter<void>();
  modalRefDescuentos: MDBModalRef;
  constructor(private carritoService:CarritoService,private novedadesService:NovedadesService,
    private utilitarioService:UtilitarioService,
    private protectedImageService: ProtectedImageService,
    private sanitizer: DomSanitizer,
    private usuarioService: UsuarioService,
    private router: Router,
    private modalService: MDBModalService) {

  }

  // rellenarCarrito(){
  //  this.precioTotal=0;
  //   this.carritoCompras=[];
    
  //   if(this.carritoDetalle){
  //     for (let i = 0; i < this.carritoDetalle.lista.length; i++) {
  //       if(this.carritoDetalle.lista[i].tipoProducto=="1"){
  //         this.novedadesService.obtenerDetalleLibro(this.carritoDetalle.lista[i].id).subscribe(data=>{
  //           this.carritoCompras.push(data.response.list);
  //           this.precioTotal = this.precioTotal + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(data.response.list[0].price) ); 
            
  //         })
  //       }
  //       else if(this.carritoDetalle.lista[i].tipoProducto=="2"){
  //         this.novedadesService.obtenerDetalleSourvenir(this.carritoDetalle.lista[i].id).subscribe(data=>{
  //           this.carritoCompras.push(data.response.list);
  //           this.precioTotal = this.precioTotal + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(data.response.list[0].price) ); 
            
  //         })
  //       }
       
  //     }
  //   }
  // }
  async rellenarCarrito(){
    // Activar flag de recarga
    this.isReloading = true;

    // Inicializar arrays
    this.precioTotal = 0;
    this.carritoCompras = [];
    this.protectedImages.clear();
    this.loadingImages.clear();
    this.itemsLoading.clear();
    this.monedaCarrito = 'S/.'; // Reset moneda

    // Crear array con placeholders para mostrar skeletons
    const tempCarrito = new Array(this.carritoDetalle.lista.length).fill(null);
    this.carritoCompras = [tempCarrito];

    // Marcar todos los items como cargando
    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {
      this.itemsLoading.add(i);
    }

    // Estructura temporal para cargar productos
    const productosTemp = [];

    // Cargar items progresivamente
    const loadPromises = this.carritoDetalle.lista.map(async (item, i) => {
      try {
        let libroDetalleTemp = new LibroDetalle();
        let sourvenirDetalleTemp = new SourvenirDetalleResponse();

        if(item.tipoProducto=="1"){
          // Enviar userId para determinar nacionalidad por tipo de documento
          const userId = this.usuarioService.obtenerIDSessionUsuario();
          libroDetalleTemp = await this.novedadesService.obtenerDetalleLibroAsync(item.id, userId).toPromise();
          libroDetalleTemp.response.list[0].size = [];

          if(Number(libroDetalleTemp.response.list[0].quantity)>10){
            libroDetalleTemp.response.list[0].quantity = "10";
          }

          let modalidadEncontrada = libroDetalleTemp.response.list[0].modalidades.find(data=>
            data.id==item.modalidadId
          );

          // Si la modalidad no existe (cambió de país), limpiar carrito
          if (!modalidadEncontrada) {
            this.limpiarCarrito();
            this.utilitarioService.toastrWarning('Tu carrito fue limpiado porque tu ubicación cambió. Los precios varían según tu país.');
            return;
          }

          const precio = modalidadEncontrada.price;

          // Determinar moneda del carrito basándose en el primer producto
          if (i === 0 && modalidadEncontrada && modalidadEncontrada.currency) {
            const currency = modalidadEncontrada.currency;
            if (currency === '$' || currency === 'USD' || currency === 'US$' ||
                currency.toLowerCase().includes('dolar') || currency.toLowerCase().includes('dollar')) {
              this.monedaCarrito = 'US$';
            } else {
              this.monedaCarrito = 'S/.';
            }
          }

          const itemData = {
            lista:libroDetalleTemp.response.list,
            cantidad:item.cantidad,
            activoId: libroDetalleTemp.response.list[0].activoId || null,
            categoryId: libroDetalleTemp.response.list[0].categoryId
          };

          // Actualizar el item específico en el array
          tempCarrito[i] = itemData;
          this.carritoCompras = [tempCarrito];

          // Agregar a estructura temporal para agrupación
          productosTemp.push({
            categoria: this.obtenerCategoria(libroDetalleTemp.response.list[0].categoryName),
            modalidadId: item.modalidadId,
            cantidad: Number(item.cantidad),
            precioUnitario: Number(precio)
          });

          // Marcar item como cargado
          this.itemsLoading.delete(i);

          // Cargar imagen después de mostrar info básica (lazy loading)
          if (libroDetalleTemp.response.list[0].activoId) {
            setTimeout(() => {
              this.loadProtectedThumbnail(String(libroDetalleTemp.response.list[0].activoId));
            }, 100); // Pequeño delay para no bloquear la UI
          }

        } else if(item.tipoProducto=="2"){
          sourvenirDetalleTemp = await this.novedadesService.obtenerDetalleSourvenirAsync(item.id).toPromise();

          if(sourvenirDetalleTemp.response.list[0].size.length>0){
            const result = sourvenirDetalleTemp.response.list[0].size.find( ({ id }) => id ==  item.sizeID);
            sourvenirDetalleTemp.response.list[0].quantity = result.stock;
            sourvenirDetalleTemp.response.list[0].sizeName = result.name;
          }

          if(Number(sourvenirDetalleTemp.response.list[0].quantity)>10){
            sourvenirDetalleTemp.response.list[0].quantity = "10";
          }

          const itemData = {
            lista:sourvenirDetalleTemp.response.list,
            cantidad:item.cantidad,
            activoId: sourvenirDetalleTemp.response.list[0].activoId || null,
            categoryId: sourvenirDetalleTemp.response.list[0].categoryId
          };

          // Actualizar el item específico en el array
          tempCarrito[i] = itemData;
          this.carritoCompras = [tempCarrito];

          // Para souvenirs, usar precio directo sin agrupación de descuentos
          let precioSouvenir = Number(sourvenirDetalleTemp.response.list[0].price);
          productosTemp.push({
            categoria: 'souvenir',
            modalidadId: null,
            cantidad: Number(item.cantidad),
            precioUnitario: precioSouvenir
          });

          // Marcar item como cargado
          this.itemsLoading.delete(i);

          // Cargar imagen después de mostrar info básica (lazy loading)
          if (sourvenirDetalleTemp.response.list[0].activoId) {
            setTimeout(() => {
              this.loadProtectedThumbnail(String(sourvenirDetalleTemp.response.list[0].activoId));
            }, 100);
          }
        }
      } catch (error) {
        console.error(`Error cargando item ${i}:`, error);
        this.itemsLoading.delete(i);
      }
    });

    // Esperar a que todos los items terminen de cargar
    await Promise.all(loadPromises);

    // Calcular total con descuentos por agrupación
    const totalCalculado = this.calcularTotalConDescuentos(productosTemp);
    this.precioTotal = totalCalculado;

    // Desactivar flag de recarga
    this.isReloading = false;

    // console.log("carritoCompras final:", this.carritoCompras);
    // console.log("precioTotal final con descuentos:", this.precioTotal);
  }

  // Método para verificar si un item específico está cargando
  isItemLoading(index: number): boolean {
    return this.itemsLoading.has(index);
  }

  loadProtectedThumbnail(activoId: string) {
    if (this.protectedImages.has(activoId) || this.loadingImages.has(activoId)) {
      return;
    }

    this.loadingImages.add(activoId);

    this.protectedImageService.getProtectedThumbnail(activoId).subscribe(
      response => {
        if (response.protectedThumbnailUrl) {
          const safeUrl = this.sanitizer.bypassSecurityTrustUrl(response.protectedThumbnailUrl);
          this.protectedImages.set(activoId, safeUrl);
        }
        this.loadingImages.delete(activoId);
      },
      error => {
        console.error('Error cargando thumbnail protegida:', error);
        this.loadingImages.delete(activoId);
      }
    );
  }

  getProtectedImageUrl(activoId: string): SafeUrl | null {
    return this.protectedImages.get(activoId) || null;
  }

  shouldShowSkeleton(activoId: string): boolean {
    return activoId && !this.protectedImages.has(activoId);
  }

  obtenerCarrito(){
    // Evitar recalcular si ya está cargando
    if (this.isLoadingCart) {
      // console.log('⚠️ Carrito-header: Ya está cargando, ignorando petición');
      return;
    }

    // console.log('📥 Carrito-header: Obteniendo carrito del servicio...');
    this.carritoDetalle = new CarritoHeader();
    this.carritoDetalle = this.carritoService.obtenerCarritoCompras();

    if (!this.carritoDetalle || !this.carritoDetalle.lista) {
      // console.log('⚠️ Carrito-header: No hay datos en el carrito');
      this.carritoCompras = [];
      this.precioTotal = 0;
      return;
    }

    // console.log('📦 Carrito-header: Items en carrito:', this.carritoDetalle.lista.length);
    this.rellenarCarrito();
  }
  limpiarCarrito(){
    // this.rellenarCarrito();
    this.carritoService.limpiarCarrito();
    this.carritoCompras = [];
    this.precioTotal = 0;
    this.protectedImages.clear();
    this.loadingImages.clear();

    // Emitir evento de item eliminado
    this.itemEliminado.emit();
  }
  obtenerPrecio(id,xd){
    const modalidad = id.modalidades.find(data => data.id == xd);
    if (!modalidad) {
      // Si la modalidad no existe (cambió de país), usar la primera disponible
      return id.modalidades.length > 0 ? id.modalidades[0].price : 0;
    }
    return modalidad.price;
  }
  obtenerModalidad(id,xd){
    const modalidad = id.modalidades.find(data => data.id == xd);
    if (!modalidad) {
      return id.modalidades.length > 0 ? id.modalidades[0].name : '';
    }
    return modalidad.name;
  }

  /**
   * Obtiene la moneda de la modalidad seleccionada.
   * Formatea "S/." para soles y "US$" para dólares.
   */
  obtenerMoneda(id, modalidadId): string {
    const modalidad = id.modalidades.find(data => data.id == modalidadId);
    if (!modalidad || !modalidad.currency) {
      return 'S/.'; // Default soles
    }

    const currency = modalidad.currency;
    // Si es dólares, formatear como US$
    if (currency === '$' || currency === 'USD' || currency === 'US$' ||
        currency.toLowerCase().includes('dolar') || currency.toLowerCase().includes('dollar')) {
      return 'US$';
    }
    // Si es soles
    return 'S/.';
  }
  feliminarCarrito(i: number){
    // console.log("Index Eliminar",i);
    this.carritoDetalle.lista.splice(i, 1);
    // console.log("carrito compras 1");
    // console.log(this.carritoDetalle);

    this.carritoService.eliminarCarrito(this.carritoDetalle.lista);

    // Limpiar cache de imágenes antes de recargar
    this.protectedImages.clear();
    this.loadingImages.clear();

    this.rellenarCarrito();

    // console.log("carrito compras 2");
    // console.log(this.carritoDetalle);

    // Emitir evento de item eliminado
    this.itemEliminado.emit();
  }
  imagen(img:String){
   
    return img.replace(/_=2?/,"");
  }
  frecalculartotal(fila:number,cantidad:number,stock:string){
    //console.log(cantidad);
    //console.log(stock);

    if (cantidad>10){
      //console.log("por defecto");
      this.carritoDetalle.lista[fila].cantidad = stock;
      this.utilitarioService.toastrInfo("cantidad maxíma : " + "10");
    }else{
      //console.log("stock");
      if (cantidad > Number(stock)){
        this.utilitarioService.toastrInfo("queda en stock : " + stock + " cantidades");
        this.carritoDetalle.lista[fila].cantidad = stock;
      }
    }

    if (cantidad<1){
      this.carritoDetalle.lista[fila].cantidad = "1";
    }

    //actualiza storage con nuevos cantidades
    this.carritoService.actualizarCarrito(this.carritoDetalle.lista);

    // Limpiar cache de imágenes antes de recalcular
    this.protectedImages.clear();
    this.loadingImages.clear();

    this.rellenarCarrito();

  }

  ngOnInit(): void {
    // Cargar el carrito inicial
    this.obtenerCarrito();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.flagActualizar) {
      // console.log('🔄 Carrito-header: Detectado cambio en flagActualizar:', changes.flagActualizar);

      // Recargar solo si no es el primer cambio (para evitar doble carga con ngOnInit)
      if (!changes.flagActualizar.firstChange) {
        // console.log('🔄 Carrito-header: Recargando carrito...');
        this.obtenerCarrito();
      }
    }
  }

  verCarrito() {
    if (!this.usuarioService.obtenerSesionUsuario()) {
      // Guardar URL del carrito para regresar después del login
      this.usuarioService.setReturnUrl('/carrito');
      this.utilitarioService.toastrWarning('Necesita iniciar sesión para ver el carrito');
      return;
    }

    // Emitir evento para cerrar el dropdown antes de navegar
    this.cerrarDropdown.emit();

    this.router.navigate(['/carrito']);
  }

  abrirPopupDescuentos() {
    this.modalRefDescuentos = this.modalService.show(
      ModalHomeComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-lg',
        containerClass: 'top',
        animated: true,
        data: {}
      }
    );
  }

  // ========== MÉTODOS PARA CÁLCULO DE DESCUENTOS POR AGRUPACIÓN ==========

  /**
   * Identifica la categoría del producto
   */
  obtenerCategoria(categoryName: string): string {
    if (!categoryName) return 'otro';

    const catUpper = categoryName.toUpperCase();
    if (catUpper.includes('FOTOGRAFIA')) return 'fotografia';
    if (catUpper.includes('PORTADA')) return 'portada';
    return 'otro';
  }

  /**
   * Agrupa productos por categoría y modalidad, y calcula el total con descuentos
   */
  calcularTotalConDescuentos(productos: any[]): number {
    // Estructura para agrupar: Map<"categoria-modalidadId", {cantidad, precioUnitario}>
    const grupos = new Map<string, {totalUnidades: number, precioUnitario: number, categoria: string, modalidadId: string}>();

    // 1. Agrupar productos por categoría + modalidad
    productos.forEach(prod => {
      // Souvenirs no se agrupan para descuentos
      if (prod.categoria === 'souvenir') {
        const key = `souvenir-${Math.random()}`; // Clave única para cada souvenir
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: 'souvenir',
          modalidadId: null
        });
        return;
      }

      // Para fotografías y portadas: agrupar por categoria-modalidad
      const key = `${prod.categoria}-${prod.modalidadId}`;

      if (grupos.has(key)) {
        const grupo = grupos.get(key);
        grupo.totalUnidades += prod.cantidad;
      } else {
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: prod.categoria,
          modalidadId: prod.modalidadId
        });
      }
    });

    // 2. Calcular total aplicando descuentos por grupo
    let totalGeneral = 0;

    grupos.forEach((grupo, key) => {
      const { totalUnidades, precioUnitario } = grupo;

      // Calcular subtotal sin descuento
      const subtotalOriginal = totalUnidades * precioUnitario;

      // Si es souvenir, calcular sin descuentos
      if (key.startsWith('souvenir-')) {
        totalGeneral += totalUnidades * precioUnitario;
        return;
      }

      // Aplicar reglas de descuento según cantidad
      let subtotal = 0;

      if (totalUnidades >= 1 && totalUnidades <= 4) {
        // Sin descuento
        subtotal = totalUnidades * precioUnitario;

      } else if (totalUnidades === 5) {
        // Pack de 5: pagas 4, llevas 5 (20% descuento efectivo)
        subtotal = 4 * precioUnitario;

      } else if (totalUnidades >= 6 && totalUnidades <= 24) {
        // 20% de descuento
        const precioConDescuento = precioUnitario * 0.8;
        subtotal = totalUnidades * precioConDescuento;

      } else if (totalUnidades >= 25) {
        // 28% de descuento total (20% + 10% adicional)
        const precioConPrimerDescuento = precioUnitario * 0.8;
        const precioFinal = precioConPrimerDescuento * 0.9;
        subtotal = totalUnidades * precioFinal;
      }

      totalGeneral += subtotal;
    });

    return Number(totalGeneral.toFixed(2));
  }

}
